<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="cardTypeData === null">Create Card Type</span>
      <span v-else>Update Card Type</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0;">
        <div class="row">
          <div class="col">
            <base-input label="Membership Program" required>
              <a-select
                v-model="formData.membership_program_id"
                :disabled="viewMode || cardTypeData !== null"
              >
                <a-select-option
                  v-for="membership_program in membershipPrograms"
                  :key="membership_program.id"
                  :value="membership_program.id"
                >
                  {{ membership_program.name }}
                </a-select-option>
              </a-select>
              <div
                v-if="$v.formData.membership_program_id.$dirty"
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="!$v.formData.membership_program_id.required"
                >
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Name" required>
              <a-input
                v-model.trim="$v.formData.name.$model"
                :disabled="viewMode"
              />
              <div v-if="$v.formData.name.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.name.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Description">
              <a-textarea
                v-model="formData.description"
                :auto-size="{ minRows: 5, maxRows: 5 }"
                :disabled="viewMode"
              />
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Prefix"
              ><a-input
                v-model="formData.prefix"
                :disabled="viewMode || cardTypeData !== null"
            /></base-input>
          </div>

          <div class="col">
            <base-input label="Suffix"
              ><a-input
                v-model="formData.suffix"
                :disabled="viewMode || cardTypeData !== null"
            /></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Card Number Series" required>
              <a-input
                v-model.trim="$v.formData.card_number_series.$model"
                :disabled="viewMode || cardTypeData !== null"
              />
              <div
                v-if="$v.formData.card_number_series.$dirty"
                class="text-danger"
              >
                <div
                  class="error"
                  v-if="!$v.formData.card_number_series.required"
                >
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Price to sell" required>
              <a-input
                v-model.trim="$v.formData.price_to_sell.$model"
                :disabled="viewMode"
              />
              <div v-if="$v.formData.price_to_sell.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.price_to_sell.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Cost to print"
              ><a-input v-model="formData.cost_to_print" :disabled="viewMode"
            /></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Status" required>
              <a-select v-model="formData.status" :disabled="viewMode">
                <a-select-option value="A">
                  Active
                </a-select-option>
                <a-select-option value="I">
                  Inactive
                </a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>

      </div>
      <div
        style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;"
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="cardTypeData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createCardType"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="editCardType"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'CardTypeForm',
  props: {
    cardTypeData: Object,
    viewMode: Boolean
  },
  data() {
    return {
      formSubmitting: false,
      formData: {
        membership_program_id: null,
        name: null,
        description: null,
        card_number_series: null,
        prefix: null,
        suffix: null,
        cost_to_print: null,
        price_to_sell: null,
        status: null
      },
      membershipPrograms: []
    };
  },
  validations: {
    formData: {
      membership_program_id: {
        required
      },
      name: { required },
      card_number_series: { required },
      price_to_sell: { required }
    }
  },
  methods: {
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.membershipPrograms = response.data.sort((a, b) =>
          a.name.localeCompare(b.name)
      );
    },

    async createCardType() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest(
          '/api/v1/clp_card_types',
          {
            card_type: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been created.'
          });
        } else {
          this.$notification.error({
            message: 'Error',
            description: 'Something went wrong. Please try again.',
            placement: 'topLeft'
          });
        }
        this.formSubmitting = false;
      }
    },
    async editCardType() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/clp_card_types/' + this.cardTypeData.id,
          {
            card_type: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been updated.'
          });
        } else {
          this.$notification.error({
            message: 'Error',
            description: 'Something went wrong. Please try again.',
            placement: 'topLeft'
          });
        }

        this.formSubmitting = false;
      }
    },
    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },
    clearForm() {
      this.formData = {
        membership_program_id: null,
        name: null,
        description: null,
        card_number_series: null,
        prefix: null,
        suffix: null,
        cost_to_print: null,
        price_to_sell: null,
        status: null
      };
    },
    setFormData(data = null) {
      if (data !== null) {
        const {
          membership_program_id,
          name,
          description,
          card_number_series,
          cost_to_print,
          price_to_sell,
          prefix,
          suffix,
          status
        } = data;

        this.formData = {
          membership_program_id,
          name,
          description,
          card_number_series,
          cost_to_print,
          price_to_sell,
          prefix,
          suffix, 
          status
        };
      } else {
        this.clearForm();
      }
    }
  },
  created() {
    this.getMembershipPrograms();
    this.setFormData(this.cardTypeData);
  },
  watch: {
    cardTypeData: function(data) {
      this.setFormData(data);
    }
  }
};
</script>

<style scoped></style>
